import { Toaster } from '@/lib/ui';

import { Providers } from './providers';
import { AppRouter } from './router';

export function App() {
  return (
    <Providers>
      <AppRouter />
      <Toaster />
    </Providers>
  );
}
